// extracted by mini-css-extract-plugin
module.exports = {"TaskList":"TaskList--3ndKy","Pagination":"Pagination--1Nzny","Skeleton":"Skeleton--38G23","Empty":"Empty--2MOxn"};